import { Controller } from "@hotwired/stimulus";

// Connects with data-controller="test-engine-dialog"
export default class extends Controller<HTMLDialogElement> {
  static targets = ["dialogElement"];

  declare dialogElementTarget: HTMLDialogElement;

  closeOutside(event: { target: HTMLDialogElement }) {
    if (event.target === this.dialogElementTarget) {
      this.close();
    }
  }
  open() {
    this.showModal();
  }

  close() {
    this.closeModal();
  }

  private showModal() {
    this.dialogElementTarget.showModal();
  }

  private closeModal() {
    this.dialogElementTarget.close();
  }
}
